<script>
  let src = "./icons/qrcode.png";
  let name = "qr";
</script>

<p>Want to get in touch?</p>
<p>Follow me on Instagram @youbylauramaebe or scan the QR-code!</p>
<p>or e-mail me: lauramaebe@outlook.com</p>

<img {src} alt={name} />

<div>
  <a href="/">
    <button>Go back to the homepage</button>
  </a>
</div>

<style>
  p {
    color: #020202;
    font-size: 2, 5em;
    font-weight: 100;
  }

  img {
    height: 150px;
    width: 150px;
    justify-content: center;
  }
</style>
